import { render, staticRenderFns } from "./SOI.vue?vue&type=template&id=2bf8c524&scoped=true&"
import script from "./SOI.vue?vue&type=script&lang=js&"
export * from "./SOI.vue?vue&type=script&lang=js&"
import style0 from "./SOI.vue?vue&type=style&index=0&id=2bf8c524&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf8c524",
  null
  
)

export default component.exports